export const PRODUCT_CATEGORY_GROUPS = [
  {
    title: 'Vehicle',
    launchPadKey: 'Vehicle',
    navCategory: 'My Wheels',
    links: [
      { label: 'Car Insurance', href: '/car-insurance-quote/' },
      { label: 'Motorbike Insurance', href: '/motorcycle-insurance-quote/' },
      { label: 'Vehicle Tracking', href: '/vehicle-tracking-quote/' },
      { label: 'Service Plans', href: '/service-plan-quotes/' },
      { label: 'Motor Warranty', href: '/motor-warranty/' },
      { label: 'Scratch & Dent Cover', href: '/dents-and-scratches-quote/' },
      { label: 'Tyre & Rim Cover', href: '/tyre-and-rim-guard/' },
      { label: 'Combo Insurance', href: '/online-insurance-quote/' },
    ],
    launchPadOptions: [
      'Car Insurance',
      'Motor Warranty',
      'Service Plans',
      'Tyre & Rim Cover',
      'Scratch & Dent Cover',
      'Vehicle Tracking',
      'Motorbike Insurance',
      'Combo Insurance',
    ],
  },
  {
    title: 'Home',
    launchPadKey: 'Home',
    navCategory: 'My Home',
    links: [
      { label: 'Home Contents Cover', href: '/home-insurance-quote/' },
      { label: 'Building Insurance', href: '/buildings-insurance-quote/' },
      { label: 'Fibre Internet', href: '/compare-fibre-deals/' },
    ],
    launchPadOptions: [
      'Home Contents Cover',
      'Building Insurance',
      'Fibre Internet',
    ],
  },
  {
    title: 'Health',
    launchPadKey: 'Medical',
    navCategory: 'My Health',
    links: [
      { label: 'Medical Aid', href: '/medical-aid-quote/' },
      { label: 'Gap Cover', href: '/medical-gap-cover-quote/' },
      { label: 'Medical Insurance', href: '/medical-insurance-quotes/' },
    ],
    launchPadOptions: ['Medical Aid', 'Gap Cover', 'Medical Insurance'],
  },
  {
    title: 'Family',
    launchPadKey: 'Life',
    navCategory: 'My Family',
    links: [
      { label: 'Travel Insurance', href: '/travel-insurance/' },
      { label: 'Pet Insurance', href: '/pet-insurance-quote/' },
      { label: 'Life Insurance', href: '/life-insurance-quote/' },
      { label: 'Funeral Insurance', href: '/funeral-insurance-quote/' },
    ],
    launchPadOptions: [
      'Life Insurance',
      'Funeral Insurance',
      'Pet Insurance',
      'Travel Insurance',
    ],
  },
  {
    title: 'Money',
    launchPadKey: 'Money',
    navCategory: 'My Money',
    links: [
      { label: 'Personal Loans', href: '/personal-loans/' },
      { label: 'Debt Counselling', href: '/debt-counselling/' },
      { label: 'Debt Consolidation', href: '/debt-consolidation-loans/' },
    ],
    launchPadOptions: [
      'Personal Loans',
      'Debt Counselling',
      'Debt Consolidation',
    ],
  },
  {
    title: 'Business',
    launchPadKey: 'Business',
    navCategory: 'My Business',
    links: [
      { label: 'Business Insurance', href: '/business-insurance-quote/' },
      {
        label: 'Car & Commercial Property Insurance',
        href: '/business-insurance-quote/car-and-commercial-property-insurance/',
      },
      {
        label: 'Business Legal Cover',
        href: '/business-insurance-quote/business-legal-cover/',
      },
      {
        label: 'Professional Liability Insurance',
        href: '/business-insurance-quote/professional-liability-insurance-cover/',
      },
      { label: 'Employee Benefits', href: '/employee-benefits-quote/' },
    ],
    launchPadOptions: [
      'Business Insurance',
      'Commercial Property Insurance',
      'Business Legal Cover',
      'Professional Liability Insurance',
      'Employee Benefits',
    ],
  },
];

export const SITE_NAV_GROUPS = [
  {
    title: 'Insurance',
    navCategory: 'Compare All',
    links: [
      { label: 'Car Insurance', href: '/car-insurance-quote/' },
      { label: 'Business Insurance', href: '/business-insurance-quote/' },
      { label: 'Life Insurance', href: '/life-insurance-quote/' },
      { label: 'Funeral Cover', href: '/funeral-insurance-quote/' },
      { label: 'Pet Insurance', href: '/pet-insurance-quote/' },
      { label: 'Home Contents Insurance', href: '/home-insurance-quote/' },
      { label: 'Buildings Insurance', href: '/buildings-insurance-quote/' },
      { label: 'Travel Insurance', href: '/travel-insurance/' },
      { label: 'Motorbike Insurance', href: '/motorcycle-insurance-quote/' },
      //  { label: 'Combo Insurance', href: '/online-insurance-quote/' },
    ],
  },
  {
    title: 'Motor',
    navCategory: 'My Wheels',
    links: [
      { label: 'Car Insurance', href: '/car-insurance-quote/' },
      { label: 'Motorbike Insurance', href: '/motorcycle-insurance-quote/' },
      { label: 'Vehicle Tracking', href: '/vehicle-tracking-quote/' },
      { label: 'Service Plans', href: '/service-plan-quotes/' },
      { label: 'Motor Warranty', href: '/motor-warranty/' },
      { label: 'Scratch & Dent Cover', href: '/dents-and-scratches-quote/' },
      { label: 'Tyre & Rim Cover', href: '/tyre-and-rim-guard/' },
    ],
  },
  {
    title: 'Health',
    navCategory: 'My Health',
    links: [
      { label: 'Medical Aid', href: '/medical-aid-quote/' },
      { label: 'Medical Insurance', href: '/medical-insurance-quotes/' },
      { label: 'Gap Cover', href: '/medical-gap-cover-quote/' },
    ],
  },
  {
    title: 'Life',
    navCategory: 'My Life',
    links: [
      { label: 'Life Insurance', href: '/life-insurance-quote/' },
      { label: 'Funeral Insurance', href: '/funeral-insurance-quote/' },
      { label: 'Pet Insurance', href: '/pet-insurance-quote/' },
      { label: 'Home Contents Insurance', href: '/home-insurance-quote/' },
      { label: 'Buildings Insurance', href: '/buildings-insurance-quote/' },
      // { label: 'Combo Insurance', href: '/online-insurance-quote/' },
      { label: 'Travel Insurance', href: '/travel-insurance/' },
      { label: 'Home Fibre', href: '/compare-fibre-deals/' },
    ],
  },
  {
    title: 'Money',
    navCategory: 'My Money',
    links: [
      { label: 'Personal Loans', href: '/personal-loans/' },
      { label: 'Debt Counselling', href: '/debt-counselling/' },
      { label: 'Debt Consolidation', href: '/debt-consolidation-loans/' },
    ],
  },
  {
    title: 'Business',
    navCategory: 'My Business',
    links: [
      { label: 'Business Insurance', href: '/business-insurance-quote/' },
      {
        label: 'Car & Commercial Property Insurance',
        href: '/business-insurance-quote/car-and-commercial-property-insurance/',
      },
      {
        label: 'Business Legal Cover',
        href: '/business-insurance-quote/business-legal-cover/',
      },
      {
        label: 'Professional Liability Cover',
        href: '/business-insurance-quote/professional-liability-insurance-cover/',
      },
      {
        label: 'Public Liability Cover',
        href: '/business-insurance-quote/compare-public-liability-insurance-quotes/',
      },
      {
        label: 'Event Liability Cover',
        href: '/business-insurance-quote/event-liability-insurance/',
      },
      { label: 'Employee Benefits', href: '/employee-benefits-quote/' },
    ],
  },
];

export const FOOTER_CATEGORY_LINK_GROUPS = [
  {
    title: 'Insurance',
    links: [
      { label: 'Car Insurance', href: '/car-insurance-quote/' },
      { label: 'Business Insurance', href: '/business-insurance-quote/' },
      { label: 'Life Insurance', href: '/life-insurance-quote/' },
      { label: 'Funeral Cover', href: '/funeral-insurance-quote/' },
      { label: 'Pet Insurance', href: '/pet-insurance-quote/' },
      { label: 'Home Contents Insurance', href: '/home-insurance-quote/' },
      { label: 'Buildings Insurance', href: '/buildings-insurance-quote/' },
      { label: 'Travel Insurance', href: '/travel-insurance/' },
      { label: 'Motorbike Insurance', href: '/motorcycle-insurance-quote/' },
      //  { label: 'Combo Insurance', href: '/online-insurance-quote/' },
    ],
  },
  {
    title: 'Motor',
    links: [
      { label: 'Car Insurance', href: '/car-insurance-quote/' },
      { label: 'Motorbike Insurance', href: '/motorcycle-insurance-quote/' },
      { label: 'Scratch & Dent Cover', href: '/dents-and-scratches-quote/' },
      { label: 'Tyre & Rim Cover', href: '/tyre-and-rim-guard/' },
      { label: 'Motor Warranty', href: '/motor-warranty/' },
      { label: 'Service Plans', href: '/service-plan-quotes/' },
      { label: 'Vehicle Tracking', href: '/vehicle-tracking-quote/' },
    ],
  },
  {
    title: 'Health',
    links: [
      { label: 'Medical Aid', href: '/medical-aid-quote/' },
      { label: 'Medical Insurance', href: '/medical-insurance-quotes/' },
      { label: 'Gap Cover', href: '/medical-gap-cover-quote/' },
    ],
  },
  {
    title: 'Life',
    links: [
      { label: 'Life Insurance', href: '/life-insurance-quote/' },
      { label: 'Funeral Insurance', href: '/funeral-insurance-quote/' },
      { label: 'Pet Insurance', href: '/pet-insurance-quote/' },
      { label: 'Home Contents Insurance', href: '/home-insurance-quote/' },
      { label: 'Buildings Insurance', href: '/buildings-insurance-quote/' },
      { label: 'Travel Insurance', href: '/travel-insurance/' },
    ],
  },
  {
    title: 'Money',
    links: [
      { label: 'Personal Loans', href: '/personal-loans/' },
      { label: 'Debt Counselling', href: '/debt-counselling/' },
      { label: 'Debt Consolidation', href: '/debt-consolidation-loans/' },
    ],
  },
  {
    title: 'Business',
    links: [
      { label: 'Business Insurance', href: '/business-insurance-quote/' },
      {
        label: 'Car & Commercial Property Insurance',
        href: '/business-insurance-quote/car-and-commercial-property-insurance/',
      },
      {
        label: 'Business Legal Cover',
        href: '/business-insurance-quote/business-legal-cover/',
      },
      {
        label: 'Professional Liability Cover',
        href: '/business-insurance-quote/professional-liability-insurance-cover/',
      },
      {
        label: 'Public Liability Cover',
        href: '/business-insurance-quote/compare-public-liability-insurance-quotes/',
      },
      {
        label: 'Event Liability Cover',
        href: '/business-insurance-quote/event-liability-insurance/',
      },
      { label: 'Employee Benefits', href: '/employee-benefits-quote/' },
    ],
  },
  {
    title: 'Internet',
    links: [{ label: 'Fibre Internet', href: '/compare-fibre-deals/' }],
  },
];

// Category landing pages, each showing the home page launchpad focused on
// that category. Used to make footer category titles clickable.
// 'Life' and 'Business' are footer-only groupings, not standalone category
// routes — both fall under the Insurance category page (same parent used by
// their breadcrumbs, see breadcrumbConfig.js), so their headings link there.
export const CATEGORY_LANDING_HREFS = {
  Insurance: '/insurance/',
  Motor: '/motor/',
  Health: '/health/',
  Money: '/money/',
  Internet: '/internet/',
  Life: '/insurance/',
  Business: '/insurance/',
};

export const LAUNCH_PAD_CATEGORY_GROUPS = [
  {
    title: 'Motor',
    launchPadKey: 'Motor',
    links: [
      { label: 'Car Insurance', href: '/car-insurance-quote/' },
      { label: 'Motor Warranty', href: '/motor-warranty/' },
      { label: 'Service Plans', href: '/service-plan-quotes/' },
      { label: 'Tyre & Rim Cover', href: '/tyre-and-rim-guard/' },
      { label: 'Scratch & Dent Cover', href: '/dents-and-scratches-quote/' },
      { label: 'Vehicle Tracking', href: '/vehicle-tracking-quote/' },
      { label: 'Motorbike Insurance', href: '/motorcycle-insurance-quote/' },
      { label: 'Combo Insurance', href: '/online-insurance-quote/' },
    ],
    launchPadOptions: [
      'Car Insurance',
      'Motor Warranty',
      'Service Plans',
      'Tyre & Rim Cover',
      'Scratch & Dent Cover',
      'Vehicle Tracking',
      'Motorbike Insurance',
      'Combo Insurance',
    ],
  },
  {
    title: 'Health',
    launchPadKey: 'Health',
    links: [
      { label: 'Medical Aid', href: '/medical-aid-quote/' },
      { label: 'Gap Cover', href: '/medical-gap-cover-quote/' },
      { label: 'Medical Insurance', href: '/medical-insurance-quotes/' },
    ],
    launchPadOptions: ['Medical Aid', 'Gap Cover', 'Medical Insurance'],
  },
  {
    title: 'Life',
    launchPadKey: 'Life',
    links: [
      { label: 'Life Insurance', href: '/life-insurance-quote/' },
      { label: 'Funeral Insurance', href: '/funeral-insurance-quote/' },
      { label: 'Pet Insurance', href: '/pet-insurance-quote/' },
      { label: 'Home Contents Cover', href: '/home-insurance-quote/' },
      { label: 'Building Insurance', href: '/buildings-insurance-quote/' },
      { label: 'Travel Insurance', href: '/travel-insurance/' },
    ],
    launchPadOptions: [
      'Life Insurance',
      'Funeral Insurance',
      'Pet Insurance',
      'Home Contents Cover',
      'Building Insurance',
      'Travel Insurance',
    ],
  },
  {
    title: 'Money',
    launchPadKey: 'Money',
    links: [
      { label: 'Personal Loans', href: '/personal-loans/' },
      { label: 'Debt Counselling', href: '/debt-counselling/' },
      { label: 'Debt Consolidation', href: '/debt-consolidation-loans/' },
    ],
    launchPadOptions: [
      'Personal Loans',
      'Debt Counselling',
      'Debt Consolidation',
    ],
  },
  {
    title: 'Business',
    launchPadKey: 'Business',
    links: [
      { label: 'Business Insurance', href: '/business-insurance-quote/' },
      {
        label: 'Car & Commercial Property Insurance',
        href: '/business-insurance-quote/car-and-commercial-property-insurance/',
      },
      {
        label: 'Business Legal Cover',
        href: '/business-insurance-quote/business-legal-cover/',
      },
      {
        label: 'Professional Liability Insurance',
        href: '/business-insurance-quote/professional-liability-insurance-cover/',
      },
      { label: 'Employee Benefits', href: '/employee-benefits-quote/' },
    ],
    launchPadOptions: [
      'Business Insurance',
      'Commercial Property Insurance',
      'Business Legal Cover',
      'Professional Liability Insurance',
      'Employee Benefits',
    ],
  },
  {
    title: 'Internet',
    launchPadKey: 'Internet',
    links: [{ label: 'Fibre Internet', href: '/compare-fibre-deals/' }],
    launchPadOptions: ['Fibre Internet'],
  },
];

const SITE_NAV_PAGES = [
  'Compare All',
  ...Array.from(
    new Set(
      SITE_NAV_GROUPS.map(({ navCategory }) => navCategory).filter(
        (navCategory) => navCategory !== 'Compare All'
      )
    )
  ),
];

export const APP_BAR_PAGES = SITE_NAV_PAGES;

export const MOBILE_MENU_SECTIONS = [...SITE_NAV_PAGES];

export const LEGACY_FOOTER_CATEGORY_LINK_GROUPS = SITE_NAV_GROUPS.map(
  ({ title, links }) => ({
    title,
    links,
  })
);

export const LAUNCH_PAD_CATEGORY_ORDER = LAUNCH_PAD_CATEGORY_GROUPS.map(
  ({ launchPadKey }) => launchPadKey
);

export const LAUNCH_PAD_PRODUCT_OPTIONS = LAUNCH_PAD_CATEGORY_GROUPS.reduce(
  (productOptions, { launchPadKey, launchPadOptions }) => ({
    ...productOptions,
    [launchPadKey]: launchPadOptions,
  }),
  {}
);

export const normalizePathname = (pathname = '') => {
  const normalizedPath = pathname.replace(/\/+$/, '');
  return normalizedPath || '/';
};

// Prefixes under which some verticals are nested one level deeper
// (e.g. /business-insurance-quote/business-legal-cover/). The base route
// for those pages is the first two segments, not just the first.
const NESTED_FLOW_PREFIXES = ['business-insurance-quote'];

export const getBaseProductRoute = (pathname = '') => {
  const cleanPath = normalizePathname(pathname);
  const segments = cleanPath.split('/').filter(Boolean);
  if (!segments.length) return '/';

  if (NESTED_FLOW_PREFIXES.includes(segments[0]) && segments.length > 1) {
    return `/${segments[0]}/${segments[1]}`;
  }

  return `/${segments[0]}`;
};
